
export function randomFromList(list) {
    // gets a random entry from the provided list
    return list[Math.floor((Math.random()*list.length))];
}

export function getStyleObject(layer, index) {
    // makes a style object out of the layers
    var imgStyle = {
        "zIndex": index,
        "left": layer.xOffset + "px",
        "top": layer.yOffset + "px"
    }, 
        transform = "";
    
    transform += " scale(" + layer.scale + "," + layer.scale + ")";

    if(layer.hFlip) {
        // flip horizontally
        transform += " scaleX(-1)";
    }

    if(layer.vFlip) {
        // flip vertically
        transform += " scaleY(-1)";
    }
    
    imgStyle.transform = transform + " rotate(" + -layer.rotation + "deg)";

    // hidden
    if(layer.hidden) {
        imgStyle.opacity = "0";
    }
    

    return imgStyle;
}


export function renameExtension(ext) {
    // rename certain extensions, eg. heads -> head
    let exts = {
        "heads": "_head",
        "eyes": "_eye",
        "mouths": "_mouth",
        "noses": "_nose",
        "hands": "_hand",
        "accessories": "",
        "custom": ""
    };

    return exts[ext] || "";
}


export function getCache() {
    // get the cache
    var cache = window.localStorage.getItem("emoji-saves");

    if(cache == undefined || cache == "") {
        cache = "[]";
    }

    return JSON.parse(cache) || [];
}

function setCache(cache) {
    window.localStorage.setItem("emoji-saves", JSON.stringify(cache) );
}

export function saveToCache(layers, n) {
    // add the current emoji to the cache
    var cache = getCache(),
        name = n;
    
    if(name == undefined) {
        name = cache.length + 1;
    }


    if(layers.length > 0) {
        cache.push( {
            "name": name,
            "layers": layers
        } );
    }

    setCache(cache);
}

export function removeFromCache(index) {
    // remove index from cache
    var cache = getCache();

    cache.splice(index, 1);

    setCache(cache);
}

export function editName(index, name) {
    // edit name of save
    var cache = getCache();

    cache[index].name = name.replace(" ", "-");

    setCache(cache);
}

export function emptyCache() {
    // clear all from queue
    setCache([]);
}
